module.exports = __webpack_public_path__ + "img/banner03_info_life.9fc74771.png";